module.exports = __webpack_public_path__ + "static/media/motic solution1.23530c5a.png";